import { Component, OnInit, Output, ViewChild, EventEmitter, Inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as _ from 'lodash';
import * as moment from 'moment';
import { AlertService } from 'src/app/services/alert.service';

@Component({
    selector: 'app-search-popup',
    templateUrl: './search-popup.component.html',
    styleUrls: ['./search-popup.component.scss'],
    providers: [DatePipe]
})

export class SearchPopupComponent implements OnInit {
    public form: FormGroup;
    @Output() addNameChange = new EventEmitter<boolean>();
    minFromDate: string;
    minToDate: string;
    defaultValue = 0;
    constructor(
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SearchPopupComponent>,
    ) {
         
         var currentDate = new Date();
         this.minFromDate = this.data.from_date;
         this.minToDate = this.data.to_date;
         
    }

    ngOnInit() {
        this.intializeValidators();  
    }
    
    intializeValidators() {

        this.form = this.formBuilder.group({
            from_date: new FormControl('', Validators.required),
            to_date: new FormControl('', Validators.required),
        });
        if(this.minFromDate != '' || this.minFromDate != null){
             this.form.controls['from_date'].setValue(this.minFromDate);
        }
        if(this.minToDate != '' || this.minToDate != null){
            this.form.controls['to_date'].setValue(this.minToDate);
       }
        
    }
    validateFormControl() {
        Object.keys(this.form.controls).forEach(field => {
          const control = this.form.get(field);
          if (control instanceof FormControl) {
            control.markAsTouched({
              onlySelf: true
            });
          }
        })
    }
    onCancel() {
        //this.dialogRef.close();
        let data = {};
        this.dialogRef.close({action: 0, data: data});
        this.ngOnInit();
    }
    onSubmit() {
        //this.dialogRef.close();
        let data = {
            'from_date': moment(this.form.get('from_date').value).format('YYYY-MM-DD'),
            'to_date': moment(this.form.get('to_date').value).format('YYYY-MM-DD'),
        };
        if(this.form.valid){
            this.dialogRef.close({action: 1, data: data});
            this.ngOnInit();
        }else{
            this.validateFormControl();
            this.alertService.error("Fill the Required fields.. Both the fields are required");
        }
        
    }
}